export type CharacterActionKey = "idle" | "run" | "sit" | "attack";

export interface CharacterActionDef {
  key: CharacterActionKey;
  label: string;
  templateLabel: string;
  hint: string;
  row: number;
}

/** Each row = 1 motion, 6 frames (columns). */
export const CHARACTER_ACTIONS: CharacterActionDef[] = [
  {
    key: "idle",
    row: 0,
    templateLabel: "IDLE",
    label: "Idle / พัก",
    hint: "การเคลื่อนไหวเดียว · 6 เฟรมยืน",
  },
  {
    key: "run",
    row: 1,
    templateLabel: "RUN",
    label: "Run / วิ่ง",
    hint: "การเคลื่อนไหวเดียว · 6 เฟรมวิ่ง",
  },
  {
    key: "sit",
    row: 2,
    templateLabel: "SIT",
    label: "Sit / นั่ง",
    hint: "การเคลื่อนไหวเดียว · 6 เฟรมนั่ง",
  },
  {
    key: "attack",
    row: 3,
    templateLabel: "ATTACK",
    label: "Attack / โจมตี",
    hint: "การเคลื่อนไหวเดียว · 6 เฟรมโจมตี",
  },
];

export const CHARACTER_ACTION_KEYS = CHARACTER_ACTIONS.map((a) => a.key);
